module.exports = __webpack_public_path__ + "static/media/inHouseIcon.0d46d769.svg";